import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";

export interface ImportTemplateCount extends AttributesMixin<typeof ImportTemplateCount> { }

@define
export class ImportTemplateCount extends Model {
  static endpoint = restfulIO('api/v1/ingest/import-templates/count');

  static attributes = {
    count: Number
  }

  parse(number: Number) {
    return { count: number }
  }
}
